import { render, staticRenderFns } from "./MemberTagForm.vue?vue&type=template&id=5d4c381b&scoped=true"
import script from "./MemberTagForm.vue?vue&type=script&lang=js"
export * from "./MemberTagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c381b",
  null
  
)

export default component.exports